import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import TicketActions from '../../store/ticketRedux';
import Section from '../../components/layout/Section';
import ContentPlain from '../../components/layout/ContentPlain';
import TicketBasicInformation from './components/TicketBasicInformation';
import TicketTabbedContainer from './components/TicketTabbedContainer';
import './TicketPage.scss'
import ErrorOutlineIcon from '../../images/error_outline.svg';
import HrbTranslate from '../../components/language/HrbTranslate';

const TicketPage = () => {
    const { id } = useParams();

    const dispatch = useDispatch();
    const ticket = useSelector(state => state.tickets.selectedTicket);    

    useEffect(() => {
        window.scrollTo(0, 0)
        if (id) {
            // reset selected ticket to null
            dispatch(TicketActions.setSelectedTicket(null));
            // request data for newly selected id
            dispatch(TicketActions.getTicket(id))
        }
    }, [id]);

    useEffect(() => {
        return () => dispatch(TicketActions.setSelectedTicket(null));
    }, [])

    return (
        <div className="content-grid tickets">
            {ticket &&  (!ticket.associateHomeOfficeId || !ticket.homeOfficeName || !ticket.officeId || !ticket.officeName) && 
            <div className='ticket-alert-container'>
                <img className='ticket-alert-icon' src={ErrorOutlineIcon} />                
                <div className='ticket-alert-section'>
                    <p className='p1'>
                        <HrbTranslate text='Tickets.MissingOffice.Title' className='ticket-alert-section-title' />
                    </p>
                    <p className='p1'>
                        <HrbTranslate text='Tickets.MissingOffice.Description' className='ticket-alert-section-description' />
                    </p>
                </div>
            </div>}
            <Section sectionId='section-ticket-base' className='white'>
                <ContentPlain elementId='content-greeting'>
                    <TicketBasicInformation ticket={ticket} />
                </ContentPlain>
            </Section>
            <TicketTabbedContainer ticket={ticket} />
        </div>
    );
}

export default TicketPage